'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = {
	_$Loader: {
		displayName: 'Loader'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var Loader = (function (_React$Component) {
	_inherits(Loader, _React$Component);

	_createClass(Loader, null, [{
		key: 'propTypes',
		value: {
			visible: _react2['default'].PropTypes.bool,
			delay: _react2['default'].PropTypes.number,
			image: _react2['default'].PropTypes.string
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			visible: false,
			delay: 400,
			opacity: 0.25,
			background: '#E5E5E5',
			image: '/img/ajax-loader.gif'
		},
		enumerable: true
	}]);

	function Loader(props) {
		var _this = this;

		_classCallCheck(this, _Loader);

		_React$Component.call(this, props);
		this.state = { visible: false };
		if (props.visible) {
			this.timeout = setTimeout(function () {
				_this.setState({ visible: true });
			}, props.delay);
		}
	}

	Loader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var _this2 = this;

		if (nextProps.visible && !this.props.visible) {
			this.timeout = setTimeout(function () {
				_this2.setState({ visible: true });
			}, this.props.delay);
		} else {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			this.state.visible = nextProps.visible;
		}
	};

	Loader.prototype.render = function render() {
		if (!this.state.visible) {
			return false;
		}

		return _react2['default'].createElement(
			'span',
			null,
			_react2['default'].createElement('div', { style: { background: this.props.background, zIndex: 1000, opacity: this.props.opacity, position: 'absolute', top: 0, width: '100%', bottom: 0 } }),
			_react2['default'].createElement(
				'div',
				{ style: { position: 'absolute', top: '50%', left: '50%', width: 64, bottom: 0 } },
				_react2['default'].createElement('img', { src: this.props.image })
			)
		);
	};

	var _Loader = Loader;
	Loader = _wrapComponent('_$Loader')(Loader) || Loader;
	return Loader;
})(_react2['default'].Component);

exports['default'] = Loader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-loader/src/Loader.js
 ** module id = 1046
 ** module chunks = 1
 **/